<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div 
      class="modal-background"
      @click="allowClose ? close() : ''">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">{{title}}</p>
          <button
            v-if="allowClose"
            @click="close()"
            class="delete"
            aria-label="close">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">Old Password*</label>
            <v-text-field 
              required
              type="password"
              placeholder="Enter Your Old Password"
              v-model="credentials.old_password">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">New Password*</label>
            <v-text-field 
              required
              type="password"
              placeholder="Enter Your New Password"
              v-model="credentials.new_password">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Confirm Your New Password*</label>
            <v-text-field 
              required
              type="password"
              placeholder="Enter Your New Password Again"
              :rules="[v => v == credentials.new_password ? true : 'Password mismatch']"
              v-model="confirmPassword">
            </v-text-field>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid || saving"
            :class="{ 'is-loading': saving }"
            class="button is-primary" 
            @click.stop="save()">
            Save New Password
          </button>
          <button
            v-if="allowClose" 
            class="button"
            @click="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    allowClose: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Please change your password'
    }
  },
  components: { VTextField, VForm },
  data() {
    return {
      credentials: {
        old_password: '',
        new_password: '',
      },
      confirmPassword: null,
      valid: false,
      saving: false
    }
  },
  methods: {
    ...mapActions("auth", ["authChangePassword"]),
    ...mapMutations("auth", ["setChangingPassword"]),
    save() {
      this.saving = true;

      this.authChangePassword(this.credentials).then(() => {
        this.setChangingPassword(false);
        this.close(true);
        this.saving = false;
        this.$router.push({ name: 'Authentication' });
      }).catch(() => this.saving = false);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
